import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const FlexContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const MainSelectContainer = styled.div<{ hasUnitSelection: boolean }>`
  flex: ${props => props.hasUnitSelection ? '60%' : '100%'};
`;

export const UnitSelectContainer = styled.div`
  flex: 40%;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const UnitSelectionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

export const UnitLabel = styled.label`
  font-size: 12px;
  font-weight: 500;
  color: #666;
`;

export const UnitSelect = styled.select`
  padding: 10px 16px;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  width: 100%;

  &:hover {
    border-color: #cbd5e0;
  }

  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }
`;

export const PricesContainer = styled.div`
  margin-top: 4px;
  padding: 4px;
  background-color: #f9f9f9;
  border-radius: 4px;
  font-size: 11px;
`;

export const NoUnitMessage = styled.div`
  font-size: 11px;
  color: #666;
  font-style: italic;
`;
